import type { Area } from 'react-easy-crop';

const MAX_SIZE = 1080;

export const getCroppedImage = (imageSrc: string, croppedAreaPixels: Area): Promise<Blob | null> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';

    image.addEventListener('load', () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        resolve(null);
        return;
      }

      // Determine output size (cap at MAX_SIZE, scale proportionally)
      const scale = Math.min(1, MAX_SIZE / Math.max(croppedAreaPixels.width, croppedAreaPixels.height));
      const outputWidth = Math.round(croppedAreaPixels.width * scale);
      const outputHeight = Math.round(croppedAreaPixels.height * scale);

      canvas.width = outputWidth;
      canvas.height = outputHeight;

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        outputWidth,
        outputHeight,
      );

      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/png');
    });

    image.addEventListener('error', () => {
      resolve(null);
    });

    image.src = imageSrc;
  });
};
